import React, { useEffect, useState } from "react";
import { Breadcrumb, BreadcrumbItem, Button, Col, Container, Form, Modal, Row, Tabs, Tab } from "react-bootstrap";
import { ReactMediaRecorder } from "react-media-recorder";
import { AddNotification, GetEmployeeList } from "../../utils/queries";
import { useSelector } from "react-redux";

const SendNotificationScreen = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const empCode = userInfo && userInfo[1]?.InfoField;
  const ReqCompanyCode = userInfo && userInfo[13]?.InfoField;

  const [header, setHeader] = useState("");
  const [subject, setSubject] = useState("");
  const [recipientType, setRecipientType] = useState("all");
  const [employeeCode, setEmployeeCode] = useState("");
  const [branchName, setBranchName] = useState("");
  const [optionalNote, setOptionalNote] = useState("");

  const [activeTab, setActiveTab] = useState("pdf");
  const [staffList, setStaffList] = useState([]);
  const [showEmployeeModal, setShowEmployeeModal] = useState(false);

  const [pdfFile, setPdfFile] = useState(null);
  const [pdfBase64, setPdfBase64] = useState("");
  const [pdfPreviewUrl, setPdfPreviewUrl] = useState("");

  const [audioUrl, setAudioUrl] = useState(null);
  const [audioBase64, setAudioBase64] = useState("");
  const [audioFile, setAudioFile] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const fetchGetEmployeeList = async () => {
      try {
        if (ReqCompanyCode) {
          const response = await GetEmployeeList(ReqCompanyCode);
          const JSONData1 = JSON.parse(response[0]?.JSONData1);
          console.log(JSONData1, "ReqCompanyCode");
          setStaffList(JSONData1);
        }
      } catch (error) {
        console.log(error, "error----GetEmployeeList");
      }
    };
    if (ReqCompanyCode) {
      fetchGetEmployeeList();
    }
  }, [ReqCompanyCode]);

  const fileToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const handlePdfChange = async (e) => {
    const file = e.target.files[0];
    setPdfFile(file);
    if (file) {
      setPdfPreviewUrl(URL.createObjectURL(file));
      const base64 = await fileToBase64(file);
      setPdfBase64(base64);
    }
  };

  const handleAudioUpload = async (e) => {
    const file = e.target.files[0];
    setAudioFile(file);
    if (file) {
      const audioURL = URL.createObjectURL(file);
      setAudioUrl(audioURL);
      const base64 = await fileToBase64(file);
      setAudioBase64(base64);
    }
  };

  console.log(activeTab)
  console.log(audioBase64)

  const handleSubmit = async (e) => {
    e.preventDefault();

    const ReqBase64 = activeTab === "pdf" ? pdfBase64 : audioBase64;

    const payload = {
      ReqSenderId: empCode,
      ReqRecipientScope: recipientType,
      ReqNotificationType: "",
      ReqEmployeeCode: recipientType === "employees" ? employeeCode : "",
      ReqEmployeeBranch: recipientType === "branch" ? branchName : "",
      ReqSubject: subject,
      ReqHeading: subject,
      ReqMetadata1: optionalNote,
      ReqMetadata2: "",
      ReqMetadata3: "",
      ReqRemarks: "created from UI",
      ReqBase64,
      ReqStatus: "unread",
    };


    try {
      const response = await AddNotification(
        payload.ReqSenderId,
        payload.ReqRecipientScope,
        payload.ReqNotificationType,
        payload.ReqEmployeeCode,
        payload.ReqEmployeeBranch,
        payload.ReqSubject,
        payload.ReqHeading,
        payload.ReqMetadata1,
        payload.ReqMetadata2,
        payload.ReqMetadata3,
        payload.ReqRemarks,
        payload.ReqBase64,
        payload.ReqStatus
      );

      console.log("Success:", response);
      setShowModal(true);
    } catch (error) {
      console.error("Submission Error:", error);
    }

    setShowModal(true);
  };

  const handleEmployeeSelect = (code) => {
    setEmployeeCode(code);
    setShowEmployeeModal(false);
  };

  return (
    <>
      <Breadcrumb>
        <BreadcrumbItem>
          <a href="/dashboard" className="text-success text-decoration-none">
            Dashboard
          </a>
        </BreadcrumbItem>
        <BreadcrumbItem active>Send Notification</BreadcrumbItem>
      </Breadcrumb>

      <Container className="form-container">
        <h4 className="text-center">Send Notification</h4>

        <Form className="border p-4 rounded bg-light mb-4" onSubmit={handleSubmit}>
          {/* Header */}
          <Row className="mb-3">
            <Col md={12}>
              <Form.Group controlId="notificationHeader">
                <Form.Label>Header</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter header"
                  value={header}
                  onChange={(e) => setHeader(e.target.value)}
                  className="form-control-hover"
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          {/* Recipient Type */}
          <Row className="mb-3">
            <Col md={12}>
              <Form.Group controlId="recipientType">
                <Form.Label>Send To</Form.Label>
                <Form.Control
                  as="select"
                  value={recipientType}
                  onChange={(e) => setRecipientType(e.target.value)}
                  className="form-control-hover"
                >
                  <option value="all">All</option>
                  <option value="employees">Employees</option>
                  <option value="branch">Branch</option>
                </Form.Control>
              </Form.Group>
            </Col>
          </Row>

          {/* Conditional: Employee Code */}
          {recipientType === "employees" && (
            <Row className="mb-3">
              <Col md={9}>
                <Form.Group controlId="employeeCode">
                  <Form.Label>Employee Code</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Employee Code"
                    value={employeeCode}
                    onChange={(e) => setEmployeeCode(e.target.value)}
                    className="form-control-hover"
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={3} className="d-flex align-items-end">
                <Button variant="secondary" onClick={() => setShowEmployeeModal(true)}>
                  List
                </Button>
              </Col>
            </Row>
          )}

          {/* Conditional: Branch Name */}
          {recipientType === "branch" && (
            <Row className="mb-3">
              <Col md={12}>
                <Form.Group controlId="branchName">
                  <Form.Label>Branch Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Branch Name"
                    value={branchName}
                    onChange={(e) => setBranchName(e.target.value)}
                    className="form-control-hover"
                    required
                  />
                </Form.Group>
              </Col>
            </Row>
          )}

          {/* Optional Note */}
          <Row className="mb-3">
            <Col md={12}>
              <Form.Group controlId="subjectNode">
                <Form.Label>Note</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Enter message"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={12}>
              <Form.Group controlId="optionalNote">
                <Form.Label>Optional Note</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Optional Note"
                  value={optionalNote}
                  onChange={(e) => setOptionalNote(e.target.value)}
                  className="form-control-hover"
                />
              </Form.Group>
            </Col>
          </Row>

          {/* Tabs for PDF / Audio */}
          <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k)} className="mb-3">
            <Tab eventKey="pdf" title="PDF">
              <Form.Group controlId="pdfUpload">
                <Form.Label>Attach PDF</Form.Label>
                <Form.Control type="file" accept="application/pdf" onChange={handlePdfChange} />
                {pdfFile && (
                  <div className="mt-2 flex">
                    <button type="button" className="me-2 bg-black px-1 py-1 rounded text-white" onClick={() => setShowModal(true)}>
                      preview
                    </button>
                    <small>Selected: {pdfFile.name}</small>
                  </div>
                )}
              </Form.Group>
            </Tab>

            <Tab eventKey="audio" title="Audio">
              <Form.Group controlId="audioOptions">
                <Form.Label>Record Audio or Upload MP3</Form.Label>

                <div className="mb-3">
                  <ReactMediaRecorder
                    audio
                    render={({ status, startRecording, stopRecording, mediaBlobUrl, previewStream, clearBlobUrl }) => (
                      <>
                        <Button type="button" variant="primary" onClick={startRecording} className="me-2">
                          Start Recording
                        </Button>
                        <Button
                          variant="danger"
                          type="button"
                          onClick={async () => {
                            stopRecording();
                            if (mediaBlobUrl) {
                              const response = await fetch(mediaBlobUrl);
                              const blob = await response.blob();
                              const base64 = await fileToBase64(blob);
                              setAudioBase64(base64);
                              setAudioUrl(mediaBlobUrl);
                            }
                          }}
                        >
                          Stop & Save
                        </Button>
                        <p className="mt-2">Status: {status}</p>
                        {mediaBlobUrl && <audio controls src={mediaBlobUrl} className="mt-2" />}
                      </>
                    )}
                  />
                </div>

                <Form.Label>Or Upload Audio</Form.Label>
                <Form.Control type="file" accept="audio/*" onChange={handleAudioUpload} />
                {audioUrl && <audio controls className="mt-2" src={audioUrl}></audio>}
              </Form.Group>
            </Tab>
          </Tabs>

          {/* Submit Button */}
          <Row>
            <Col className="text-center mt-2">
              <Button type="submit" variant="primary" className="px-4">
                Send Notification
              </Button>
            </Col>
          </Row>
        </Form>

        {/* PDF Preview Modal */}
        {pdfFile && (
          <Modal show={showModal && activeTab === "pdf"} onHide={() => setShowModal(false)} size="lg">
            <Modal.Header closeButton>
              <Modal.Title>PDF Preview</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <iframe src={pdfPreviewUrl} width="100%" height="500px" title="PDF Preview"></iframe>
            </Modal.Body>
          </Modal>
        )}

        <Modal show={showEmployeeModal} onHide={() => setShowEmployeeModal(false)} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Select Employee</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div style={{ maxHeight: "500px", overflowY: "auto" }}>
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>Emp Code</th>
                    <th>Name</th>
                    <th>Designation</th>
                    <th>Type</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {staffList.map((emp) => (
                    <tr key={emp.EMPAUTOID}>
                      <td>{emp.EMPCODE}</td>
                      <td>{emp.EmployeeName}</td>
                      <td>{emp.Designation}</td>
                      <td>{emp.EmployeeType}</td>
                      <td>
                        <Button size="sm" onClick={() => handleEmployeeSelect(emp.EMPCODE)}>
                          Select
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Modal.Body>
        </Modal>
      </Container>
    </>
  );
};

export default SendNotificationScreen;
